// @flow

import { reduce } from 'lodash';
import { $set, update } from 'qim';

import FieldUtils from 'app/beta-editor/utils/FieldUtils';

import type { Field } from 'app/beta-editor/types';
import type { FlowState, MaybeSkinnyFlow } from 'app/beta-editor/flowState';
import type { ID } from 'app/common/types';

export const updateNeeds = (
  flow: MaybeSkinnyFlow,
  nodeId: ID,
  needs: Array<Field>
) => {
  const node = flow.nodes[nodeId];
  const newNeeds = FieldUtils.normalizeFieldsForFormatic(needs);
  const extraFields = FieldUtils.buildExtraFields(newNeeds, node.params);

  return update(
    [
      ['needs', nodeId, $set(FieldUtils.removeMissingFields(newNeeds))],
      ['dirtyNeeds', nodeId, $set(false)],
      ['isLoadingNeeds', $set(false)],
      ['extraNeeds', nodeId, $set(extraFields)],
      [
        'missingNeeds',
        nodeId,
        $set(FieldUtils.retrieveMissingFields(newNeeds, node.params)),
      ],
    ],
    flow
  );
};

export const clearNeeds = (flow: MaybeSkinnyFlow, nodeId: ID) => {
  return update(
    [
      ['needs', nodeId, $set([])],
      ['dirtyNeeds', nodeId, $set(false)],
      ['isLoadingNeeds', $set(false)],
      ['extraNeeds', nodeId, $set([])],
      ['missingNeeds', nodeId, $set({})],
    ],
    flow
  );
};

export const updateAllNeeds = (
  flow: MaybeSkinnyFlow,
  allNeeds: { [nodeId: ID]: Array<Field> }
) =>
  reduce(
    allNeeds,
    (newFlow, needs, nodeId) => updateNeeds(newFlow, nodeId, needs),
    flow
  );

export const setStepMenuState = (
  state: FlowState,
  flowId: ID,
  index: number,
  newValue: any
) => {
  const stepMenuStatePath = ['flows', flowId, 'openStepMenus', index];
  return update([...stepMenuStatePath, $set(newValue)], state);
};
